// Design tokens for the Elliott "Add New Program" conversational flow.
// Ported from the Elliott lesson redesign (feat/elliott-course-redesign) so the
// avatar + chat experience matches. Sizes are tuned slightly tighter than the
// full-page lesson because this thread lives inside the 550px right-pane drawer.

export const elliottTokens = {
  // Fills
  bg: '#0F0F0F', // Fill/Modal/background — matches the drawer paper
  surface: '#1C1C1C', // raised surfaces (input, unselected pills)
  surfaceHover: '#151515',

  // Brand
  brandDark: '#F15A26', // orange/700
  brandLight: '#F79420', // orange/500

  // Text
  textPrimary: '#FDFDFD',
  textSecondary: '#B6B6B6',
  textTertiary: '#868686',

  // Strokes
  borderDim: '#2A2A2A',
  borderContrast: '#444444',

  // Status
  success: '#00972D',
  error: '#EF4444',

  // "Brandy" gradient — vertical, both stops vivid so text never fades into the dark bg.
  brandyTextGradient: 'linear-gradient(180deg, #F79420 0%, #F15A26 100%)',
  brandyFill: 'linear-gradient(180deg, rgba(247,148,32,0.75) 0%, rgba(241,90,38,0.75) 100%)',

  // Shape / type — slightly smaller than the lesson page to suit the narrow pane.
  radius: 8,
  bodySize: 15,
  bodyLineHeight: 22
} as const;
